import { COLORS } from "@/app/common/consts/colors";
import React from "react";
import type { IconProps } from "./type";

const Share = ({ color = "lightblack" }: IconProps) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.6667 4.00002C10.6667 2.15907 12.1591 0.666687 14.0001 0.666687C15.841 0.666687 17.3334 2.15907 17.3334 4.00002C17.3334 5.84097 15.841 7.33335 14.0001 7.33335C12.9968 7.33335 12.0971 6.89012 11.486 6.18877L7.26015 8.30168C7.30815 8.52688 7.33342 8.7605 7.33342 9.00002C7.33342 9.37237 7.27236 9.73045 7.15973 10.0648L11.253 12.1115C11.8541 11.2388 12.8603 10.6667 14.0001 10.6667C15.841 10.6667 17.3334 12.1591 17.3334 14C17.3334 15.841 15.841 17.3334 14.0001 17.3334C12.1591 17.3334 10.6667 15.841 10.6667 14C10.6667 13.8951 10.6716 13.7913 10.6811 13.6889L6.24021 11.4684C5.64838 12.0059 4.86248 12.3334 4.00008 12.3334C2.15913 12.3334 0.666748 10.841 0.666748 9.00002C0.666748 7.15907 2.15913 5.66669 4.00008 5.66669C5.00336 5.66669 5.90311 6.10993 6.5142 6.81127L10.74 4.69836C10.692 4.47316 10.6667 4.23954 10.6667 4.00002Z"
        fill="white"
      />
    </svg>
  );
};

export default Share;
